const MS_PER_DAY = 1000 * 60 * 60 * 24;

class DateUtils {
  public static getUnixTimestamp(date: Date = new Date()): number {
    return Math.round(+date / 1000);
  }

  public static dateFromUnixTimestamp(timestamp: number): Date {
    return new Date(timestamp * 1000);
  }

  public static roundToMiliseconds(date: Date = new Date()): Date {
    return this.dateFromUnixTimestamp(this.getUnixTimestamp(date));
  }

  public static daysDateDiff(d1: Date, d2: Date): number {
    const utc1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
    const utc2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());
    return Math.floor((utc2 - utc1) / MS_PER_DAY);
  }

  public static toDatetime = (date: Date) => {
    return date
      .toISOString()
      .slice(0, 19)
      .replace('T', ' ');
  };

  public static addMinutes(minutes: number, date: Date = new Date()): Date {
    const result = new Date(date);
    result.setMinutes(result.getMinutes() + minutes);
    return result;
  }

  public static subtractMinutes(minutes: number, date: Date = new Date()): Date {
    return this.addMinutes(-minutes, date);
  }

  public static addDays(days: number, date: Date = new Date()): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
}

export default DateUtils;
